import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';
import { FlightInfoCardComponent } from './flight-info-card/flight-info-card.component';

@NgModule({
  declarations: [FlightInfoCardComponent],
  imports: [CommonModule, SharedModule],
  exports: [FlightInfoCardComponent],
})
export class FlightInfoModule {}
